import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Rewind = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="rewind icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M20.0001 12.4557C20.0001 8.31355 16.6424 4.95569 12.5004 4.95569C10.9193 4.95569 9.45214 5.44429 8.24176 6.28084L9.89656 7.57375C10.5259 8.06548 10.3533 9.06022 9.59506 9.31113L2.52423 11.651C1.84681 11.8752 1.15932 11.3381 1.21295 10.6265L1.77267 3.19942C1.83269 2.40298 2.75609 1.99484 3.38545 2.48656L4.99419 3.74348C7.00735 2.00763 9.6308 0.955688 12.5004 0.955688C18.8514 0.955688 24 6.10441 24 12.4557C24 18.807 18.8514 23.9557 12.5004 23.9557C8.51137 23.9557 4.99794 21.9229 2.93837 18.846C2.32396 17.9281 2.56998 16.6859 3.48785 16.0714C4.40573 15.457 5.6479 15.703 6.2623 16.6209C7.61107 18.636 9.90199 19.9557 12.5004 19.9557C16.6424 19.9557 20.0001 16.5978 20.0001 12.4557Z"
    />
  </svg>
)
